type WhenCondition<M> = (value: M) => boolean;
type WhenResult<T, R> = (value: T) => R;
interface Match<M, R> {
  when: <T extends M>(condition: WhenCondition<M> | M, value: WhenResult<T, R> | R) => this;
  or: <T extends M>(value: WhenResult<T, R> | R) => this;
  do: (value?: M) => R;
  toFunc: () => (value: M) => R;
}
export function match<M, R>(match?: M): Match<M, R> {
  let orCase: WhenResult<unknown, R> = () => {
    throw Error('Incomplete pattern match');
  };
  const cases: { condition: WhenCondition<M> | M; result: unknown }[] = [];
  function when<T extends M>(
    condition: WhenCondition<M> | M,
    result: WhenResult<T, R>
  ): Match<M, R> {
    cases.push({ condition, result });
    return this as Match<M, R>;
  }
  function or<T extends M>(result: WhenResult<T, R>): Match<M, R> {
    orCase = typeof result === 'function' ? result : () => result;
    return this as Match<M, R>;
  }
  function _do(value: M): R {
    const m = match ? match : value;
    const { result } = cases.find(({ condition }) =>
      typeof condition === 'function' ? (condition as WhenCondition<M>)(m) : condition === m
    ) || { result: orCase };
    return typeof result === 'function' ? (result(value) as R) : (result as R);
  }
  const toFunc = () => _do;
  return {
    when,
    or,
    do: _do,
    toFunc
  };
}
